import React from "react";
import PropTypes from "prop-types";
import config from "../../../config";

const BookingStep6 = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 text-center p-4">
      <div className="success-icon mb-4">
      <img src={config.imagepath + "success.svg"} alt="" />
      </div>
      <h2 className="mb-3" style={{ color: "#3a3432" }}>
        Booking Successful
      </h2>
      <p className="text-muted mb-5" style={{ maxWidth: "500px" }}>
        Thank you for your booking. You may change this appointment online up to 48 hours before your appointment. For changes to your appointment after that time please contact the Salon.
      </p>
    </div>
  );
};

BookingStep6.propTypes = {
  isBookingStep: PropTypes.number,
  bookingStepName: PropTypes.string,
  isBookingSelectedServicesData: PropTypes.oneOfType([
    PropTypes.node, 
    PropTypes.array, 
    PropTypes.object
  ]),
};

export default BookingStep6;
